import { render, staticRenderFns } from "./squeue_field.vue?vue&type=template&id=3453d4e3&lang=pug"
import script from "./squeue_field.vue?vue&type=script&lang=js"
export * from "./squeue_field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports